import { useForm, useController } from "react-hook-form";
import { useState, useEffect } from "react";
import validator from "validator";
import AsyncSelect from "react-select/async";
import axios from "axios";
import { getGeneralTypes, postData, postDataResponse, postUploadDocument } from "./Services";
import { StyledSelect, InputContainer, InputWrapper, HeaderContainer, HeaderText, NoteField, GreyButton, RedButton, RightJustifyDiv, SubmitSpan } from "./Style";
//import { Grid, TextField, Button, Card, CardContent, CardHeader, Typography, InputLabel, MenuItem, FormControl, Select } from '@mui/material/';

import { Grid, TextField,Backdrop, Button, Card, CircularProgress, CardContent, CardHeader, Typography, InputLabel, MenuItem, FormControl, Select } from '@mui/material/';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import { styled } from '@mui/material/styles';
import { useMsal } from "@azure/msal-react";
import { useNavigate } from 'react-router-dom';
import ConfirmDialog from "./ConfirmDialog";

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const CaseDocForm = ({ onSave, Case = {} }) => {
  const [MatterID, setMatterID] = useState([]);
  const [DocTypeID, setDocTypeID] = useState([]);
  const [errorRequest, setErrorRequest] = useState(false);
  const [notes, setNotes] = useState('');
  const [selectedValueMatterID, setSelectedValueMatterID] = useState("");
  const [selectedValueDocType, setSelectedValueDocType] = useState("");
  const [selectedFiles, setSelectedFiles] = useState(null);

  const [userEmail, setUserEmail] = useState('');
  const { instance } = useMsal();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [hasFile, setHasFile] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [dialogMessage, SetDialogMessage] = useState("");
  const [isUploading, setUploading] = useState(false);
  const [dialogDestUrl,  setDialogDestUrl] = useState("");

  //const { register, handleSubmit, watch, control } = useForm();
  //const [selectedValue, setSelectedValue] = useState("");
  //let watchID = watch("id");
  //const { field } = useController({ name: "MatterIDSelect", control });


  useEffect(() => {

    async function fetchInitialData(_email) {
      //Matter ID dropdown
      const currentAccount = instance.getActiveAccount();
      var body = {};
      if (currentAccount) {
        setUserEmail(currentAccount.username); //(currentAccount.username);
        body.email = currentAccount.username; //currentAccount.username;
      }

      const tokenRequest = {
        account: currentAccount, // This is an example - Select account based on your app's requirements
        scopes: ["User.Read"]
      }
      const matterIDResponse = await postDataResponse('/User/MatterList', body);  //await getMatterID(body.email);
      matterIDResponse.errors ? setErrorRequest(true) : setMatterID(matterIDResponse.data);

      const DocTypeResponse = await getGeneralTypes('/Settings/DocumentTypes');
      DocTypeResponse.errors ? setErrorRequest(true) : setDocTypeID(DocTypeResponse); 
    }

    fetchInitialData();
  }, [instance, userEmail]);

  const handleSelectChangeDocType = (event) => {
    setSelectedValueDocType(event.target.value);
  };

  const handleSelectChangeMatterID = (event) => {
    setSelectedValueMatterID(event.target.value);
  };

  const selectFile = (event) => {
    setSelectedFiles(event.target.files);
  }

  const upload = async () => {
    const form = new FormData();
  }



  async function handleSubmit(e) {
    e.preventDefault();
    setUploading(true);

    // Read the form data
    const form = e.target;
    const formData = new FormData(form);
    const formJson = Object.fromEntries(formData.entries());

    let _mID = formJson.MatterIDSelect;
    let _dtype = formJson.DocTypeSelect;
    let _notes = formJson.txtNotes;

    setIsValid(true);
    setHasFile(true);
    if (_dtype == "") {
      setIsValid(false);
    }

    if (!selectedFiles) {
      setHasFile(false);
    }

    if (selectedFiles.length > 0) {
      const selectedFile = selectedFiles[0];
      formData.append("file", selectedFile);
      let _fileName = selectedFile.name;

      let _guidFileNameObject = await postUploadDocument(
        '/Matter/Document/Upload', formData);

      let postObject = {
        EMail: userEmail,
        MatterID: _mID,
        Type: _dtype,
        Note: _notes,
        Filename: _fileName,
        GuidFileName: _guidFileNameObject.data.filename
      };

      postDataResponse('/Matter/SubmitDocument', postObject).then((response) => {
        setUploading(false);
        if (response.status === 200 || response.status === 201) {
          setIsSuccess(true);
          SetDialogMessage("Document Successfully sent to City Attorney's Office");
        }
        else
        {
          setIsSuccess(false);
          SetDialogMessage(response.data);
        }
        setOpenDialog(true); 
      });

      /*let response = await postDataResponse('/Matter/SubmitDocument', postObject);
      if (response.status == 200 || response.status == 201) {
        setIsSubmitted(true);
        navigate('/Success?message=Document Successfully sent to ProLaw');
      }
      else {
        setIsSubmitted(false);
      }*/
    }
  };

  const handleCloseDialog = () => { setOpenDialog(false); };
  return (
    <form onSubmit={handleSubmit}>
      <div>
          <Card className="form-card">
            <CardHeader title="Submit Case Document" style={{ backgroundColor: "#8B0E04", color: "#fff" }} />
            <CardContent>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <FormControl fullWidth margin="normal">
                      <InputLabel id="MatterIDSelectLbl">Matter ID</InputLabel>
                      <Select
                        labelId="MatterIDSelectLbl"
                        id="MatterIDSelect"
                        name="MatterIDSelect"
                        label="Matter ID"                        
                        value={selectedValueMatterID}
                        onChange={handleSelectChangeMatterID}
                        required
                      >
                        <MenuItem value="">Choose a Matter</MenuItem >
                        {MatterID !== null ? MatterID.map((value) => (
                          <MenuItem key={value.id} value={value.id}>
                            {"\"" + value.id + "\" - " + value.description + " - " + value.clientSort}
                          </MenuItem >
                        )) : <MenuItem ></MenuItem >}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid xs={12} item>
                    <FormControl fullWidth margin="normal">
                      <InputLabel id="DocumentTypeLbl">Document Type</InputLabel>
                      <Select
                        name="DocTypeSelect"
                        labelId="DocumentTypeLbl"
                        id="DocumentTypeSelect"
                        value={selectedValueDocType}
                        label="Document Type"
                        onChange={handleSelectChangeDocType}
                        required
                      >
                        <MenuItem value="">Choose a Document Type</MenuItem >
                        {MatterID !== null ? DocTypeID.map((value) => (
                          <MenuItem key={value.Key} value={value.Key}>
                            {value.Value}
                          </MenuItem>
                        )) : <MenuItem ></MenuItem >}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid xs={12} item>
                    <TextField
                      name="txtNotes"
                      label="Document Name" variant="outlined" margin="normal"
                      multiline
                      rows={3}
                      maxRows={15}
                      value={notes}
                      onChange={e => setNotes(e.target.value)}
                      required
                      fullWidth
                      placeholder="Document Name"

                    />
                  </Grid>


                  <Grid item xs={12} sm={9}>
                    <TextField
                      id="outlined-read-only-input"
                      fullWidth
                      defaultValue="Please select a file"
                      value={selectedFiles && selectedFiles.length > 0 ? selectedFiles[0].name : "Please select a file"}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} alignItems="stretch" style={{ display: "flex" }}>
                    
                  <Button component="label" variant="contained" style={{ backgroundColor: "rgb(207, 66, 64)" }} startIcon={<CloudUploadIcon />} 
                      onChange={selectFile} fullWidth>
                                    Upload file
                    <VisuallyHiddenInput type="file" />
                  </Button>                     
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Button type="submit" variant="contained" style={{ backgroundColor: "rgb(207, 66, 64)" }} fullWidth>Submit</Button>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Button type="reset" variant="contained" style={{ backgroundColor: "rgb(51, 51, 51)" }} fullWidth>Clear</Button>
                  </Grid>

                </Grid>
            </CardContent>
          </Card>
          <Backdrop
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
            open={isUploading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
      </div>
      <ConfirmDialog 
          isOpen={openDialog}
          onClose={handleCloseDialog}
          isSuccess={isSuccess}
          message = {dialogMessage}
          destination={dialogDestUrl}
        />
    </form>
  );
};
export default CaseDocForm;
